import { withParams } from 'vuelidate';
export default withParams({ type: 'accountNumberLength18Or24Digit' }, (value) => {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}
	const valueLength = value.replace(/\D/g, '').length;
	return valueLength == 16 || valueLength == 24;
});
